/**
 * Simple utility function to sleep for a given amount of time in milliseconds.
 * @param ms - Number of milliseconds to sleep (must be a non-negative integer)
 * @throws {Error} When ms is negative, decimal, NaN, Infinity, or not a number
 */
export default function sleep(ms: number): Promise<void> {
  if (
    typeof ms !== "number" ||
    !Number.isInteger(ms) ||
    ms < 0 ||
    !Number.isFinite(ms)
  ) {
    throw new Error(
      `sleep() requires a non-negative integer, received: ${ms} (${typeof ms})`,
    );
  }

  return new Promise((r) => setTimeout(r, ms));
}
